import loadable from '@loadable/component'
import { createRenderTarget } from 'component-library/render-target'
import { Logger } from 'typescript-log'
import { LinkClickedEvent } from 'common/events/component-events'
import { PlayerEvent } from 'common/events/video-event-types'

// Implementing lazy loaded components is explained in README.md
export const LazyAmpEmbed = loadable(() => import('component-library/publication/Embed/Embed.amp'))

export const LazyRssEmbed = loadable(() => import('component-library/publication/Embed/Embed.rss'))

export const LazyWebEmbed = loadable(() => import('component-library/publication/Embed/Embed.web'))

export const LazyPreviewEmbed = loadable(() =>
    import('component-library/publication/Embed/Embed.preview')
)

export interface EmbedProps {
    link: string
    onEvent: (event: PlayerEvent | LinkClickedEvent) => void
    log: Logger
    adUnitPath: string
}

export const Embed = createRenderTarget<EmbedProps>('Embed', {
    amp: LazyAmpEmbed,
    web: LazyWebEmbed,
    rss: LazyRssEmbed,
    preview: LazyPreviewEmbed,
})
